import {API_URL} from "./constants";

export const headers = {
  "Content-Type": "application/json",
};

//////////////////////////////////// SURYA AIB API START ////////////////////////////////////

export const REGISTER_USER = {
  method: "POST",
  url: `${API_URL}/register`,
  headers: headers,
};

export const LOGIN_USER = {
  method: "POST",
  url: `${API_URL}/login`,
  headers: headers,
};

export const VERIFY_OTP = {
  method: "POST",
  url: `${API_URL}/otp_verify`,
  headers: headers,
};

export const RESEND_OTP = {
  method: "POST",
  url: `${API_URL}/resend_otp`,
  headers: headers,
};

export const FORGOT_PASS = {
  method: "POST",
  url: `${API_URL}/forgot_password`,
  headers: headers,
};

export const LOGOUT_USER = {
  method: "POST",
  url: `${API_URL}/logout`,
  headers: headers,
};

export const UPDATE_PASS = {
  method: "POST",
  url: `${API_URL}/update_password`,
  headers: headers,
};

export const LINK_CHECK = {
  method: "POST",
  url: `${API_URL}/link_check`,
  headers: headers,
};

export const VERIFY_EMAIL = {
  method: "POST",
  url: `${API_URL}/verify_email`,
  headers: headers,
};

export const UPDATE_PROFILE = {
  method: "POST",
  url: `${API_URL}/update_profile`,
  headers: headers,
};

export const DASHBOARD = {
  method: "POST",
  url: `${API_URL}/dashboard`,
  headers: headers,
};

export const AGENT_CLIENTS = {
  method: "POST",
  url: `${API_URL}/agent_clients`,
  headers: headers,
};

export const PROPOSAL_FORM = {
  method: "POST",
  url: `${API_URL}/proposal_form`,
  headers: headers,
};

export const PROPOSAL_DETAILS = {
  method: "POST",
  url: `${API_URL}/get_proposal_details`,
  headers: headers,
};

export const PENDING_PROPOSALS = {
  method: "POST",
  url: `${API_URL}/pending_proposal`,
  headers: headers,
};

export const DELETE_PROPOSAL = {
  method: "POST",
  url: `${API_URL}/delete_proposal`,
  headers: headers,
};

export const SUBMITTED_PROPOSALS = {
  method: "POST",
  url: `${API_URL}/submited_proposal`,
  headers: headers,
};

export const CONTACT_US = {
  method: "POST",
  url: `${API_URL}/contact_us`,
  headers: headers,
};

export const REQUEST_CLAIM = {
  method: "POST",
  url: `${API_URL}/request_claim`,
  headers: headers,
};

export const PAYMENT = {
  method: "POST",
  url: `${API_URL}/payment`,
  headers: headers,
};

export const GET_EMI_DETAILS = {
  method: "POST",
  url: `${API_URL}/get_emi_details`,
  headers: headers,
};

export const ENDORSEMENT_LIST = {
  method: "POST",
  url: `${API_URL}/endorsements_list`,
  headers: headers,
};

export const AGENT_ENDORSEMENTS_LIST = {
  method: "POST",
  url: `${API_URL}/agent_endorsements_list`,
  headers: headers,
};

export const REQUEST_ENDORSEMENT = {
  method: "POST",
  url: `${API_URL}/request_endorsements`,
  headers: headers,
};

export const EXHIBITIONS = {
  method: "POST",
  url: `${API_URL}/exhibition_list`,
  headers: headers,
};

export const AGENT_EXHIBITIONS = {
  method: "POST",
  url: `${API_URL}/agent_exhibition_list`,
  headers: headers,
};

export const REQUEST_EXHIBITION = {
  method: "POST",
  url: `${API_URL}/request_exhibition_coverage`,
  headers: headers,
};

export const GET_EXHIBITION_COVERAGE = {
  method: "POST",
  url: `${API_URL}/get_exhibition_coverage`,
  headers: headers,
};

export const GET_ADDRESS = {
  method: "POST",
  url: `${API_URL}/get_address`,
  headers: headers,
};

export const AGENT_PENDING_PROPOSALS = {
  method: "POST",
  url: `${API_URL}/agent_pending_proposal`,
  headers: headers,
};

export const AGENT_SUBMITTED_PROPOSALS = {
  method: "POST",
  url: `${API_URL}/agent_submited_proposal`,
  headers: headers,
};

export const CLAIM_LIST = {
  method: "POST",
  url: `${API_URL}/claim_list`,
  headers: headers,
};

export const AGENT_CLAIM_LIST = {
  method: "POST",
  url: `${API_URL}/agent_claim_list`,
  headers: headers,
};

export const DOCUSIGN_PREPARE = {
  method: "POST",
  url: `${API_URL}/docusign/prepare`,
  headers: headers,
};

export const DOCUSIGN_SUCCESS = {
  method: "POST",
  url: `${API_URL}/docusign/docusign_success`,
  headers: headers,
};

export const ISSUED_POLICIES = {
  method: "POST",
  url: `${API_URL}/issued_policy`,
  headers: headers,
};

export const AGENT_ISSUED_POLICIES = {
  method: "POST",
  url: `${API_URL}/agent_issued_policy`,
  headers: headers,
};

export const GET_DETAILS = {
  method: "POST",
  url: `${API_URL}/get_details`,
  headers: headers,
};

export const POLICY_RENEW = {
  method: "POST",
  url: `${API_URL}/policy_renew`,
  headers: headers,
};

export const AGENT_POLICY_RENEW = {
  method: "POST",
  url: `${API_URL}/agent_policy_renew`,
  headers: headers,
};

export const GET_PAYMENT_URL = {
  method: "POST",
  url: `${API_URL}/get_payment_url`,
  headers: headers,
};

export const DIAMOND_FORM = {
  method: "POST",
  url: `${API_URL}/diamond_form`,
  headers: headers,
};

export const DIA_PROPOSAL_LIST = {
  method: "POST",
  url: `${API_URL}/dia_proposal_list`,
  headers: headers,
};

export const AGENT_DIA_PROPOSAL_LIST = {
  method: "POST",
  url: `${API_URL}/agent_dia_proposal_list`,
  headers: headers,
};

export const DELETE_DIA_PROPOSAL = {
  method: "POST",
  url: `${API_URL}/delete_dia_proposal`,
  headers: headers,
};

//////////////////////////////////// SURYA AIB API END ////////////////////////////////////
